var map = {
	"./Auth/routes.js": 1518,
	"./Home/ActivityLog/routes.js": 1519,
	"./Home/Attendance/AIDataVisualizer/routes.js": 1520,
	"./Home/Attendance/Backup/routes.js": 1521,
	"./Home/Attendance/Calendar/routes.js": 1522,
	"./Home/Attendance/Clocking/routes.js": 1523,
	"./Home/Attendance/ClockingCheck/routes.js": 1524,
	"./Home/Attendance/Device/DeviceChart/routes.js": 1525,
	"./Home/Attendance/Device/DeviceList/routes.js": 1526,
	"./Home/Attendance/Device/Flash/routes.js": 1527,
	"./Home/Attendance/Device/routes.js": 1528,
	"./Home/Attendance/Diagrams/routes.js": 1529,
	"./Home/Attendance/Forgiveness/Assignment/routes.js": 1530,
	"./Home/Attendance/Forgiveness/Definition/routes.js": 1531,
	"./Home/Attendance/Forgiveness/routes.js": 1532,
	"./Home/Attendance/Leave/AmountLeave/routes.js": 1533,
	"./Home/Attendance/Leave/AutoTransfer/routes.js": 1534,
	"./Home/Attendance/Leave/Cardex/routes.js": 1535,
	"./Home/Attendance/Leave/LeaveReport/routes.js": 1536,
	"./Home/Attendance/Leave/UserAmountLeaveTransfer/routes.js": 1537,
	"./Home/Attendance/Leave/routes.js": 1538,
	"./Home/Attendance/ManagerOpinion/routes.js": 1539,
	"./Home/Attendance/Modifier/routes.js": 1540,
	"./Home/Attendance/MonthlyManagerOpinion/routes.js": 1541,
	"./Home/Attendance/Policy/Definition/routes.js": 1542,
	"./Home/Attendance/Policy/Positions/routes.js": 1543,
	"./Home/Attendance/Policy/Users/routes.js": 1544,
	"./Home/Attendance/Policy/routes.js": 1545,
	"./Home/Attendance/Reports/routes.js": 1546,
	"./Home/Attendance/Rules/routes.js": 1657,
	"./Home/Attendance/Salary/Assignment/routes.js": 1658,
	"./Home/Attendance/Salary/FactorSalary/routes.js": 1659,
	"./Home/Attendance/Salary/Modifier/routes.js": 1660,
	"./Home/Attendance/Salary/Post/routes.js": 1661,
	"./Home/Attendance/Salary/Report/routes.js": 1662,
	"./Home/Attendance/Salary/RulePack/routes.js": 1663,
	"./Home/Attendance/Salary/SalaryFish/routes.js": 1664,
	"./Home/Attendance/Salary/SalaryItems/routes.js": 1665,
	"./Home/Attendance/Salary/WritsSalary/routes.js": 1666,
	"./Home/Attendance/Salary/routes.js": 1667,
	"./Home/Attendance/Setting/Definition/routes.js": 1668,
	"./Home/Attendance/Setting/Personnel/routes.js": 1669,
	"./Home/Attendance/Setting/Positions/routes.js": 1670,
	"./Home/Attendance/Setting/Users/routes.js": 1671,
	"./Home/Attendance/Setting/routes.js": 1672,
	"./Home/Attendance/SettingAttendance/Patterns/Assignment/routes.js": 1673,
	"./Home/Attendance/SettingAttendance/Patterns/Definition/routes.js": 1674,
	"./Home/Attendance/SettingAttendance/Patterns/RulePack/routes.js": 1675,
	"./Home/Attendance/SettingAttendance/Patterns/routes.js": 1676,
	"./Home/Attendance/SettingAttendance/Sms/ApiSettings/routes.js": 1677,
	"./Home/Attendance/SettingAttendance/Sms/Assignment/routes.js": 1678,
	"./Home/Attendance/SettingAttendance/Sms/Definition/routes.js": 1679,
	"./Home/Attendance/SettingAttendance/Sms/Log/routes.js": 1680,
	"./Home/Attendance/SettingAttendance/Sms/routes.js": 1681,
	"./Home/Attendance/SettingAttendance/routes.js": 1682,
	"./Home/Attendance/Shift/Assignment/routes.js": 1683,
	"./Home/Attendance/Shift/Definition/routes.js": 1684,
	"./Home/Attendance/Shift/Positions/routes.js": 1685,
	"./Home/Attendance/Shift/Users/routes.js": 1686,
	"./Home/Attendance/Shift/routes.js": 1687,
	"./Home/Attendance/Shift/userShifts/routes.js": 1688,
	"./Home/Attendance/Stack/History/routes.js": 1689,
	"./Home/Attendance/Stack/Packs/Definition/routes.js": 1690,
	"./Home/Attendance/Stack/Packs/Positions/routes.js": 1691,
	"./Home/Attendance/Stack/Packs/Users/routes.js": 1692,
	"./Home/Attendance/Stack/Packs/routes.js": 1693,
	"./Home/Attendance/Stack/Rules/routes.js": 1694,
	"./Home/Attendance/Stack/routes.js": 1695,
	"./Home/Attendance/WorkingHours/routes.js": 1696,
	"./Home/Attendance/Writs/routes.js": 1697,
	"./Home/Attendance/routes.js": 1698,
	"./Home/Basic/AppSetting/routes.js": 1699,
	"./Home/Basic/Category/routes.js": 1700,
	"./Home/Basic/OrganizationChart/routes.js": 1701,
	"./Home/Basic/Permission/Roles/Assignment/routes.js": 1702,
	"./Home/Basic/Permission/Roles/Definition/routes.js": 1703,
	"./Home/Basic/Permission/Roles/routes.js": 1704,
	"./Home/Basic/Permission/Tiny/Personnel/routes.js": 1705,
	"./Home/Basic/Permission/Tiny/Position/routes.js": 1706,
	"./Home/Basic/Permission/routes.js": 1707,
	"./Home/Basic/Personnel/routes.js": 1708,
	"./Home/Basic/routes.js": 1709,
	"./Home/Bulletin/Category/routes.js": 1710,
	"./Home/Bulletin/Post/routes.js": 1711,
	"./Home/Bulletin/routes.js": 1712,
	"./Home/Cartable/routes.js": 1713,
	"./Home/CompanySetting/routes.js": 1714,
	"./Home/Dashboard/routes.js": 1715,
	"./Home/Evaluation360/Evaluation/routes.js": 1716,
	"./Home/Evaluation360/Period/routes.js": 1717,
	"./Home/Evaluation360/Question/Assignment/routes.js": 1718,
	"./Home/Evaluation360/Question/QuestionCategory/routes.js": 1719,
	"./Home/Evaluation360/Question/Questionnaire/routes.js": 1720,
	"./Home/Evaluation360/Question/routes.js": 1721,
	"./Home/Evaluation360/Report/routes.js": 1722,
	"./Home/Evaluation360/Settings/Contact/routes.js": 1723,
	"./Home/Evaluation360/Settings/Setting360/routes.js": 1724,
	"./Home/Evaluation360/Settings/routes.js": 1725,
	"./Home/Evaluation360/routes.js": 1726,
	"./Home/Feed/DateFoodMeal/routes.js": 1727,
	"./Home/Feed/Device/routes.js": 1728,
	"./Home/Feed/Food/routes.js": 1729,
	"./Home/Feed/Meal/routes.js": 1730,
	"./Home/Feed/Report/DateFoodMeal/routes.js": 1731,
	"./Home/Feed/Report/General/routes.js": 1732,
	"./Home/Feed/Report/ReserveFood/routes.js": 1733,
	"./Home/Feed/Report/Separation/routes.js": 1734,
	"./Home/Feed/Report/routes.js": 1735,
	"./Home/Feed/Reserve/routes.js": 1736,
	"./Home/Feed/ReservePrint/All/routes.js": 1737,
	"./Home/Feed/ReservePrint/User/routes.js": 1738,
	"./Home/Feed/ReservePrint/routes.js": 1739,
	"./Home/Feed/SelfService/routes.js": 1740,
	"./Home/Feed/Writs/routes.js": 1741,
	"./Home/Feed/routes.js": 1742,
	"./Home/Guardian/Live/routes.js": 1810,
	"./Home/Guardian/Report/routes.js": 1743,
	"./Home/Guardian/Request/routes.js": 1744,
	"./Home/Guardian/Status/routes.js": 1745,
	"./Home/Guardian/routes.js": 1746,
	"./Home/ManagementDecisions/routes.js": 1747,
	"./Home/ManagementDecisions/test/routes.js": 1748,
	"./Home/Map/Assignment/routes.js": 1749,
	"./Home/Map/ClockingCheck/routes.js": 1750,
	"./Home/Map/Map/routes.js": 1751,
	"./Home/Map/routes.js": 1752,
	"./Home/Notices/routes.js": 1753,
	"./Home/Notices/test/routes.js": 1754,
	"./Home/Payroll copy/routes.js": 1755,
	"./Home/Payroll/routes.js": 1756,
	"./Home/Poll/routes.js": 1757,
	"./Home/Poll/test/routes.js": 1758,
	"./Home/Profile/routes.js": 1759,
	"./Home/Requests/Box/Draft/routes.js": 1760,
	"./Home/Requests/Box/Inbox/routes.js": 1761,
	"./Home/Requests/Box/Outbox/routes.js": 1762,
	"./Home/Requests/Box/routes.js": 1763,
	"./Home/Requests/Dashboard/routes.js": 1764,
	"./Home/Requests/History/routes.js": 1765,
	"./Home/Requests/Pattern/Assignment/routes.js": 1766,
	"./Home/Requests/Pattern/RulePack/routes.js": 1767,
	"./Home/Requests/Pattern/routes.js": 1768,
	"./Home/Requests/Procedure/Definition/routes.js": 1769,
	"./Home/Requests/Procedure/Search/routes.js": 1770,
	"./Home/Requests/Procedure/routes.js": 1771,
	"./Home/Requests/Rules/routes.js": 1772,
	"./Home/Requests/Status/routes.js": 1773,
	"./Home/Requests/routes.js": 1774,
	"./Home/Salary/Assignment/routes.js": 1775,
	"./Home/Salary/FactorSalary/routes.js": 1776,
	"./Home/Salary/Modifier/routes.js": 1777,
	"./Home/Salary/Post/routes.js": 1778,
	"./Home/Salary/Report/routes.js": 1779,
	"./Home/Salary/SalaryFish/routes.js": 1780,
	"./Home/Salary/SalaryItems/routes.js": 1781,
	"./Home/Salary/WritsSalary/routes.js": 1782,
	"./Home/Salary/routes.js": 1783,
	"./Home/Settings/routes.js": 1784,
	"./Home/Sms/ApiSettings/routes.js": 1785,
	"./Home/Sms/Assignment/routes.js": 1786,
	"./Home/Sms/Definition/routes.js": 1787,
	"./Home/Sms/Log/routes.js": 1788,
	"./Home/Sms/routes.js": 1789,
	"./Home/Test/CustomPrint/routes.js": 1790,
	"./Home/Test/Import/routes.js": 1791,
	"./Home/Test/Laboratory/routes.js": 1809,
	"./Home/Test/Live/routes.js": 1792,
	"./Home/Test/Stack/routes.js": 1793,
	"./Home/Test/Storage/routes.js": 1794,
	"./Home/Test/routes.js": 1795
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1517;